import Vue from 'vue'

Vue.directive('scroll', {
  inserted: function (el, binding) {
    let cb = binding.value
    function onMouseWheel (ev) { /* 当鼠标滚轮事件发生时，执行一些操作 */
      ev = ev || window.event
      let down = true // 定义一个标志，当滚轮向下滚时，执行一些操作
      down = ev.wheelDelta ? ev.wheelDelta < 0 : ev.detail > 0
      // eslint-disable-next-line standard/no-callback-literal
      cb(down ? 'down' : 'up')
      if (ev.preventDefault) { /* FF 和 Chrome */
        ev.preventDefault()// 阻止默认事件
      }
      return false
    }
    addEvent(el, 'mousewheel', onMouseWheel)
    addEvent(el, 'DOMMouseScroll', onMouseWheel)
  }
})

function addEvent (target, tEvent, fn) {
  if (target.attachEvent) {
    target.attachEvent('on' + tEvent, fn)
  } else {
    target.addEventListener(tEvent, fn, false)
  }
}
